const filtersKeys = [
  'departure_date',
  'departure_date_custom',
  'trip_type',
  'trip_language',
  'price',
  'organiser_pk',
  'place_id',
  'organiserTitle',
  'near_by',
  'tag',
]

const filtersToClean = [
  'trip_type',
  'trip_language',
  'price',
  'organiser_pk',
  'place_id',
  'organiserTitle',
  'near_by',
  'tag',
]

export { filtersKeys, filtersToClean }
